// *********************************
// ****__OPERACIONES DE ERRORPAGE__****
//  0: no hace nada
// -1: error controlado
// -2: error fatal
// -3: error de negocio
// -6: Tapón mantenimiento
// **********************************
export const handlingCodes = {
  NOTHINGTODO: 0,
  CONTROLLED: -1,
  FATAL: -2,
  MAINTENANCE: -6,
};

const getSpecificErrorHandler = (handleErrorsObj, error) => {
  const errorStr = `code_${error}`;
  if (typeof handleErrorsObj !== 'object') {
    return null;
  }
  if (handleErrorsObj[errorStr]) {
    return handleErrorsObj[errorStr];
  }

  return handleErrorsObj.default;
};

export const catchTCOLError = (error) => {
  let errorCode = '';
  let errorDetails = '';

  try {
    errorCode = error.response.error.codigoErrorNegocio;
    errorDetails = error.response.error.descripcionErrorNegocio;
  } catch (err) {
    // FAILED TO CATCH TCOL ERROR
  }
  return { errorCode, errorDetails };
};
export const getErrorInfo = (error) => {
  let errorCode = '';
  let errorDetails = '';
  if (error) {
    ({ errorCode, errorDetails } = catchTCOLError(error));
    if (!errorCode && !errorDetails) {
      errorCode = error.status;
      errorDetails = error.response;
    }
  } else {
    errorCode = '500';
    errorDetails = 'Error en el servidor';
  }
  return { errorCode, errorDetails };
};

const getErrorType = (errorCode) => {
  let errorType;
  if (
    !errorCode ||
    !errorCode.length ||
    charIsCapitalLetter(errorCode.charCodeAt(errorCode.length - 1))
  ) {
    return null;
  }
  for (let i = errorCode.length - 1; i > 0; i--) {
    if (errorCode[i] === '-') {
      errorType = errorCode.slice(0, i);
      break;
    }
  }

  return errorType;
};

const charIsCapitalLetter = (char) => {
  if (char > 64 && char < 91) {
    return true;
  }
  return false;
};

export const normalizeTechnicalErrors = (
  webServiceOrigin,
  error,
  webServiceErrorHandler,
  handledErrors,
) => {
  const { errorCode, errorDetails } = { ...getErrorInfo(error) };
  const handleErrorsObj = webServiceErrorHandler[webServiceOrigin];
  const specificHandler = getSpecificErrorHandler(handleErrorsObj, errorCode);

  let errorToPrint = null;
  if (handledErrors.DEFAULT_ERROR) {
    errorToPrint = handledErrors.DEFAULT_ERROR;
  }

  if (specificHandler) {
    const { handlingCode } = specificHandler;

    switch (handlingCode) {
      case handlingCodes.CONTROLLED:
      case handlingCodes.FATAL:
        if (webServiceOrigin) {
          const handledErrorsByOrigin =
            handledErrors.WEB_SERVICES_RULES[webServiceOrigin];

          if (handledErrorsByOrigin) {
            let possibleError = handledErrorsByOrigin[errorCode];

            if (possibleError) {
              errorToPrint = possibleError;
            } else {
              possibleError = null;
              let errorType = errorCode;
              for (;;) {
                possibleError = handledErrorsByOrigin[errorType];
                if (possibleError) {
                  break;
                } else {
                  errorType = getErrorType(errorType);
                  if (!errorType) {
                    break;
                  }
                }
              }

              if (possibleError) {
                errorToPrint = possibleError;
              } else {
                possibleError = handledErrorsByOrigin.DEFAULT_ERROR;

                if (possibleError) {
                  errorToPrint = possibleError;
                }
              }
            }
          }
        }
        break;
      case handlingCodes.NOTHINGTODO:
      case handlingCodes.MAINTENANCE:
      default:
        errorToPrint = null;
        break;
    }
  }

  if (errorToPrint && errorToPrint.errorInfo) {
    errorToPrint = {
      ...errorToPrint,
      errorInfo: {
        ...errorToPrint.errorInfo,
        errorCode,
        errorDetails,
      },
    };
  }

  return errorToPrint;
};
